import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const LookupsContext = createContext(null);

export function LookupsProvider({ children }) {
  const [lookups, setLookups] = useState(null);

  useEffect(() => {
    api.get("/lookups").then(({ data }) => setLookups(data)).catch(() => setLookups(null));
  }, []);

  return <LookupsContext.Provider value={lookups}>{children}</LookupsContext.Provider>;
}

export function useLookups() {
  return useContext(LookupsContext);
}
